<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col lg="6" cols="7">
          <!-- <h6 class="h2 text-white d-inline-block mb-0">{{ motorbike._name }}</h6> -->
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block" v-if="$route.meta.breadcrumbTitle">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
        <b-col lg="6" cols="5" class="text-right">
          <base-dropdown menu-on-right
                     class="btn-neutral btn-sm"
                     tag="base-button"
                     title-tag="span"
                     title="Options"
                     menuClasses="">

        <template>
          <b-dropdown-item @click="onDeleteMotorbike">
            <i class="ni ni-fat-remove"></i>
            <span>Delete</span>
          </b-dropdown-item>
          <div class="dropdown-divider"></div>
          <b-dropdown-item :to="{name: 'checkpoints', query: { motorbike: $route.params.id }}">
            <i class="ni ni-active-40"></i>
            <span>Checkpoints</span>
          </b-dropdown-item>
          <b-dropdown-item :to="{name: 'maintenances', query: { motorbike: $route.params.id }}">
            <i class="ni ni-settings"></i>
            <span>Maintenance</span>
          </b-dropdown-item>
          <b-dropdown-item :to="{name: 'motorbikeCharts' }">
            <i class="ni ni-chart-bar-32"></i>
            <span>Charts</span>
          </b-dropdown-item>
          <!-- <b-dropdown-item @click="logout">
            <i class="ni ni-user-run"></i>
            <span>Logout</span>
          </b-dropdown-item> -->
        </template>
      </base-dropdown>
        </b-col>
      </b-row>
      <!-- Card stats -->
      <b-row>
        <b-col md="6" xl="3">
          <stats-card title="Odometer" type="gradient-red"
            :sub-title="String(metrics.motorbikeOdometer.odometer) + ' km'" icon="ni ni-world-2">
        
            <template slot="footer">
              <span class="mr-2">{{ metrics.motorbikeOdometer.odometerFromAcquisition }} km</span>
              <span class="text-nowrap">Since acquisition</span>
            </template>
          </stats-card>
        </b-col>
        <b-col md="6" xl="3">
          <stats-card title="Distance rode" type="gradient-orange"
            :sub-title="String(metrics.mileageTwoMonths.thisMonthMeters) + ' km'" icon="ni ni-world-2">
        
            <template slot="footer">
              <span class="mr-2" :class="{
                                      'text-success': metrics.mileageTwoMonths.thisMonth > metrics.mileageTwoMonths.lastMonth,
                                      'text-danger': metrics.mileageTwoMonths.lastMonth > metrics.mileageTwoMonths.thisMonth
                                    }"><i class="fa" :class="{
                                      'fa-arrow-up': metrics.mileageTwoMonths.thisMonth > metrics.mileageTwoMonths.lastMonth,
                                      'fa-arrow-down': metrics.mileageTwoMonths.lastMonth > metrics.mileageTwoMonths.thisMonth
                                    }"></i> {{ metrics.mileageTwoMonths.lastMonthPercentage }}%</span>
              <span class="text-nowrap">Versus last month</span>
            </template>
          </stats-card>
        </b-col>
        <b-col md="6" xl="3">
          <stats-card title="Days rode" type="gradient-green" :sub-title="String(metrics.daysTwoMonths.thisMonth) + ' days'"
            icon="ni ni-calendar-grid-58">
        
            <template slot="footer">
              <span class="mr-2" :class="{
                                                    'text-success': metrics.daysTwoMonths.thisMonth > metrics.daysTwoMonths.lastMonth,
                                                    'text-danger': metrics.daysTwoMonths.lastMonth > metrics.daysTwoMonths.thisMonth
                                                  }"><i class="fa" :class="{
                                                    'fa-arrow-up': metrics.daysTwoMonths.thisMonth > metrics.daysTwoMonths.lastMonth,
                                                    'fa-arrow-down': metrics.daysTwoMonths.lastMonth > metrics.daysTwoMonths.thisMonth
                                                  }"></i> {{ metrics.daysTwoMonths.lastMonthPercentage }}%</span>
              <span class="text-nowrap">Versus last month</span>
            </template>
          </stats-card>
        
        </b-col>
        <b-col md="6" xl="3">
          <stats-card title="Cost" type="gradient-info" :sub-title="String(metrics.maintenanceCostTwoMonths.thisMonth) + ' €'"
            icon="ni ni-money-coins">
        
            <template slot="footer">
              <span class="mr-2" :class="{
                                                  'text-danger': metrics.maintenanceCostTwoMonths.thisMonth > metrics.maintenanceCostTwoMonths.lastMonth,
                                                  'text-success': metrics.maintenanceCostTwoMonths.lastMonth > metrics.maintenanceCostTwoMonths.thisMonth
                                                }"><i class="fa" :class="{
                                                  'fa-arrow-up': metrics.maintenanceCostTwoMonths.thisMonth > metrics.maintenanceCostTwoMonths.lastMonth,
                                                  'fa-arrow-down': metrics.maintenanceCostTwoMonths.lastMonth > metrics.maintenanceCostTwoMonths.thisMonth
                                                }"></i> {{ metrics.maintenanceCostTwoMonths.lastMonthPercentage }}%</span>
              <span class="text-nowrap">Versus last month</span>
            </template>
          </stats-card>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--5">
      <div class="card mb-4">
        <!-- Card header -->
        <div class="card-header">
          <h3 class="mb-0">Motorbike details</h3>
        </div>
        <!-- Card body -->
        <div class="card-body">
          <b-form @submit.prevent="updateMotorbike">
          <b-row>
            <b-col>
              <b-row><b-col><h5>Motorbike</h5></b-col></b-row>
              <b-row>
                <b-col lg="12">
                  <div class="form-group">
                    <label class="form-control-label" for="brand">Brand</label>
                    <input type="text" class="form-control" id="brand" placeholder="Brand" v-model="model.brand">
                  </div>
                </b-col>
                <b-col lg="12">
                  <div class="form-group">
                    <label class="form-control-label" for="model">Model</label>
                    <input type="text" class="form-control" id="model" placeholder="Model" v-model="model.model">
                  </div>
                </b-col>
                <b-col lg="12">
                  <div class="form-group">
                    <label class="form-control-label" for="color">Color</label>
                    <input type="text" class="form-control" id="color" placeholder="Color" v-model="model.color">
                  </div>
                </b-col>
                <b-col lg="12">
                  <div class="form-group">
                    <label class="form-control-label" for="cc">CC</label>
                    <input type="number" class="form-control" id="cc" placeholder="CC" v-model="model.cc">
                  </div>
                </b-col>
                <b-col lg="12">
                  <div class="form-group">
                    <label class="form-control-label" for="licenseplate">Licenseplate</label>
                    <input type="text" class="form-control" id="licenseplate" placeholder="Licenseplate" v-model="model.licenseplate">
                  </div>
                </b-col>
              </b-row>
            </b-col>
            <b-col>
              <b-row><b-col><h5>Acquisition</h5></b-col></b-row>
              <b-row>
                <b-col lg="12">
                  <div class="form-group">
                    <label class="form-control-label" for="acquisitionDate">Acquisition date</label>
                    <base-input type="date" placeholder="Acquisition date" v-model="model._date" @change="dateChanged"/>
                  </div>
                </b-col>
                <b-col lg="12">
                  <div class="form-group">
                    <label class="form-control-label" for="acquisitionKm">Acquisition mileage</label>
                    <input type="number" class="form-control" id="acquisitionKm" placeholder="Acquisition mileage" v-model="model.acquisitionKm">
                  </div>
                </b-col>
                <b-col lg="12">
                  <div class="form-group">
                    <label class="form-control-label" for="acquisitionProvider">Acquisition provider</label>
                    <input type="text" class="form-control" id="acquisitionProvider" placeholder="Acquisition provider" v-model="model.acquisitionProvider">
                  </div>
                </b-col>
                <b-col lg="12">
                  <div class="form-group">
                    <label class="form-control-label" for="acquisitionPrice">Acquisition price</label>
                    <input type="number" step="any" class="form-control" id="acquisitionPrice" placeholder="Acquisition price" v-model="model.acquisitionPrice">
                  </div>
                </b-col>
                <b-col lg="12">
                  <div class="form-group">
                    <label class="form-control-label" for="firstRegistrationDate">First registration Date</label>
                    <base-input type="date" placeholder="First registration Date" v-model="model._firstRegistrationDate" @change="firstDateChanged"/>
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="text-right">
              <base-button type="primary" native-type="submit" class="my-4" :disabled="!hasChanges">Save</base-button>
            </b-col>
          </b-row>
          </b-form>
        </div>
      </div>
    </b-container>
  </div>
</template>
<script>
  import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
  import StatsCard from '@/components/Cards/StatsCard';
  import { mapActions, mapGetters } from 'vuex';
  import MetricsAPI from '../../api/metrics'

  export default {
    name: 'starter-page',
    components: {
      StatsCard,
      RouteBreadCrumb
    },
    data() {
      return {
        model: {},
        metrics: {
          daysTwoMonths: { thisMonth: '', lastMonth: '' },
          maintenanceCostTwoMonths: { thisMonth: '', lastMonth: '' },
          mileageTwoMonths: { thisMonth: '', lastMonth: '', thisMonthMeters: '' },
          motorbikeOdometer: { odometer: '', odometerFromAcquisition: '' },
          motorbikesTwoMonths: { thisMonth: '', lastMonth: '' }
        }
      };
    },
    async beforeMount() {
      await this.getMotorbike(this.$route.params.id)
      this.model = {
        acquisitionDate: this.motorbike.acquisitionDate,
        acquisitionKm: this.motorbike.acquisitionKm,
        acquisitionProvider: this.motorbike.acquisitionProvider,
        acquisitionPrice: this.motorbike.acquisitionPrice,
        brand: this.motorbike.brand,
        cc: this.motorbike.cc,
        color: this.motorbike.color,
        licenseplate: this.motorbike.licenseplate,
        model: this.motorbike.model,
        firstRegistrationDate: this.motorbike.firstRegistrationDate,
        _date: this.motorbike.acquisitionDate && new Date(this.motorbike.acquisitionDate).toInputDateFormat(),
        _firstRegistrationDate: this.motorbike.firstRegistrationDate && new Date(this.motorbike.firstRegistrationDate).toInputDateFormat()
      }
      this.$route.meta.breadcrumbTitle = this.motorbike._name

    },
    async mounted() {
      this.getDaysTwoMonths()
      this.getMaintenanceCostTwoMonths()
      this.getMotorbikeOdometer()
      this.getMileageTwoMonths()
    },
    methods: {
      ...mapActions({
        getMotorbike: 'motorbikes/show',
        editMotorbike: 'motorbikes/edit',
        deleteMotorbike: 'motorbikes/delete'
      }),
      async updateMotorbike() {
        await this.editMotorbike({ id: this.$route.params.id, data: this.model })
      },
      onDeleteMotorbike() {
        this.deleteMotorbike(this.$route.params.id)
        this.$router.push({ path: '/motorbikes' })
      },
      dateChanged() {
        this.model.acquisitionDate = this.model._date && this.model._date.fromInputDateFormatToDate().toISOString()
      },
      firstDateChanged() {
        this.model.firstRegistrationDate = this.model._firstRegistrationDate && this.model._firstRegistrationDate.fromInputDateFormatToDate().toISOString()
      },
      getMotorbikeOdometer() {
        MetricsAPI.motorbikeOdometer({ motorbike: this.$route.params.id })
          .then(metric => {
            this.metrics.motorbikeOdometer = metric
            if (this.metrics.motorbikeOdometer.odometer) {
              this.metrics.motorbikeOdometer.odometer = Math.round(this.metrics.motorbikeOdometer.odometer)
            }
            if (this.metrics.motorbikeOdometer.odometerFromAcquisition) {
              this.metrics.motorbikeOdometer.odometerFromAcquisition = Math.round(this.metrics.motorbikeOdometer.odometerFromAcquisition)
            }
          })
      },
      getMileageTwoMonths() {
        MetricsAPI.mileageTwoMonth({ motorbike: this.$route.params.id })
          .then(metric => {
            this.metrics.mileageTwoMonths = metric
            this.metrics.mileageTwoMonths.thisMonthMeters = metric.thisMonth / 1000
            this.metrics.mileageTwoMonths.lastMonthMeters = metric.lastMonth / 1000
            const percent = metric.thisMonth / metric.lastMonth * 100 - 100
            if (percent === Infinity) {
              this.metrics.mileageTwoMonths.lastMonthPercentage = 100
            } else if (isNaN(percent)) {
              this.metrics.mileageTwoMonths.lastMonthPercentage = 0
            } else {
              this.metrics.mileageTwoMonths.lastMonthPercentage = Math.abs(metric.thisMonth / metric.lastMonth * 100 - 100).toFixed()
            }
          })
      },
      getDaysTwoMonths() {
        MetricsAPI.daysTwoMonth({ motorbike: this.$route.params.id })
          .then(metric => {
            this.metrics.daysTwoMonths = metric
            const percent = metric.thisMonth / metric.lastMonth * 100 - 100
            if (percent === Infinity) {
              this.metrics.daysTwoMonths.lastMonthPercentage = 100
            } else if (isNaN(percent)) {
              this.metrics.daysTwoMonths.lastMonthPercentage = 0
            } else {
              this.metrics.daysTwoMonths.lastMonthPercentage = Math.abs(metric.thisMonth / metric.lastMonth * 100 - 100).toFixed()
            }
          })
      },
      getMaintenanceCostTwoMonths() {
        MetricsAPI.maintenanceCostTwoMonth({ motorbike: this.$route.params.id })
          .then(metric => {
            this.metrics.maintenanceCostTwoMonths = metric
            const percent = metric.thisMonth / metric.lastMonth * 100 - 100
            if (percent === Infinity) {
              this.metrics.maintenanceCostTwoMonths.lastMonthPercentage = 100
            } else if (isNaN(percent)) {
              this.metrics.maintenanceCostTwoMonths.lastMonthPercentage = 0
            } else {
              this.metrics.maintenanceCostTwoMonths.lastMonthPercentage = Math.abs(metric.thisMonth / metric.lastMonth * 100 - 100).toFixed()
            }
          })
      }
    },
    computed: {
      ...mapGetters({
        motorbike: 'motorbikes/motorbike'
      }),
      hasChanges () {
        let changes = 0
        const keys = [
          'acquisitionDate',
          'acquisitionKm',
          'acquisitionProvider',
          'acquisitionPrice',
          'brand',
          'cc',
          'color',
          'licenseplate',
          'model',
          'firstRegistrationDate'
        ]
        Object.keys(this.model).filter(k => keys.indexOf(k) > -1).forEach(key => {
          if (this.motorbike[key] !== this.model[key]) {
            changes++
          }
        })
        return !!(changes)
      }
    }
  };
</script>
<style scoped>
  .starter-page {
    min-height: calc(100vh - 380px);
  }
  .dropdown {
    z-index: 1000;
  }
</style>
